const conf = {
  username: {
    label: 'Username',
    fixedValue: '@',
    minLen: 3,
    maxLen: 21,
    oneColumn: true,
  },
  email: {
    label: 'Email',
    placeholder: 'your@email.com',
    validator: 'email',
    oneColumn: true,
  },
  password: {
    label: 'Password',
    component: 'forms.PasswordField',
    fieldStore: 'forms.PasswordFieldStore',
    placeholder: '8 characters minimum',
    minLen: 8,
    draftDisabled: true,
    oneColumn: true,
  },
  fullName: {
    label: 'Full Name',
    placeholder: 'First and Last name',
    minLen: 3,
    maxLen: 30,
  },
  preferredName: {
    label: 'Preferred Name',
    placeholder: 'What shall we call you?',
    optional: true,
  },
  bio: {
    label: 'Bio',
    component: 'forms.TextAreaField',
    placeholder: '160 characters maximum',
    optional: true,
    minLen: 3,
    maxLen: 160,
  },
  description: {
    label: 'Description',
    component: 'forms.TextAreaField',
    placeholder: '300 characters maximum',
    minLen: 3,
    maxLen: 300,
    optional: true,
  },
  url: {
    label: 'Url',
    placeholder: 'www.website.com',
    optional: true,
    validator: 'url',
  },
  tags: {
    component: 'forms.ListField',
    itemComponent: 'tags.itemComponent',
    fieldStore: 'tag.TagsFieldStore',
    label: 'Topics',
    itemName: 'tag',
    prefixValue: '#',
    maxLen: 10,
    appKey: 'name',
    placeholder: 'e.g. #robotics #arduino #3d-printing',
    autocomplete: {
      heading: 'Do you mean:',
      completeField: 'inputValue',
      completeVar: 'complete',
      ArrayApp: 'TagsApp',
      query: 'tags.CompleteTagsQuery',
      allowNew: true,
      optionComponent: 'tags.autocompleteElement',
    },
  },
  profiles: {
    label: 'Wikifactory users',
    component: 'forms.ListField',
    itemComponent: 'profiles.itemComponent',
    itemName: 'user',
    newItemPrompt: 'Enter/Tab to add this Email',
    placeholder: 'Start typing...',
    appKey: 'username',
    newValueValidator: 'invitation',
    autocomplete: {
      heading: 'Do you mean...',
      completeField: 'inputValue',
      completeVar: 'complete',
      ArrayApp: 'ProfilesApp',
      query: 'profile.CompleteProfilesQuery',
      allowNew: true,
      toLowerCase: true,
      optionComponent: 'profile.autocompleteElement',
    },
  },
  spacesComplete: {
    component: 'forms.ListField',
    fieldStore: 'forms.ArrayFieldStore',
    placeholder: 'Type a username/workspace name...',
    itemComponent: 'space.spaceItem',
    itemName: 'space',
    labelKey: 'title',
    appKey: 'id',
    noValidationIcon: true,
    autocomplete: {
      heading: 'Do you mean...',
      query: 'spaces.CompleteSpacesQuery',
      optionComponent: 'space.spaceOption',
      ArrayApp: 'SpacesApp',
      completeField: 'inputValue',
      completeVar: 'complete',
    },
  },
  inSpace: {
    label: 'Workspace',
    component: 'forms.SelectField',
    selectionComponent: 'space.spaceComponent',
    fieldStore: 'forms.ReferenceFieldStore',
    placeholder: 'Select',
    labelKey: 'path',
    appKey: 'id',
    optional: false,
    options: {
      optionComponent: 'space.spaceOption',
      allowNew: false,
      // ArrayApp: 'SpacesApp',
      heading: 'Please select',
    },
  },
  inSpaceWithQuery: {
    label: 'Workspace',
    component: 'forms.SelectField',
    selectionComponent: 'space.spaceComponent',
    fieldStore: 'forms.ReferenceFieldStore',
    placeholder: 'Select',
    labelKey: 'path',
    appKey: 'id',
    optional: false,
    options: {
      query: 'space.canCreateInSpaces',
      optionComponent: 'space.spaceOption',
      allowNew: false,
      ArrayApp: 'SpacesApp',
      heading: 'Please select',
    },
  },
  taxId: {
    label: 'Tax ID',
    placeholder: 'Only required for businesses and freelancers',
    optional: true,
    maxLen: 15,
    draftDisabled: true,
  },
  organizationType: {
    label: 'My Team is a...',
    placeholder: 'Choose one of the options',
    labelKey: 'name',
    appKey: 'id',
    fieldStore: 'forms.StringFieldStore',
    optional: false,
    component: 'forms.SelectField',
    options: {
      query: 'organization.OrganizationTypesQuery',
    },
  },
  invites: {
    title: 'Invite collaborators',
    label: 'Invitations (email or username)',
    type: 'profiles',
    optional: true,
  },
  process: {
    label: 'Fabrication Process',
    placeholder: 'Choose Process',
    component: 'forms.SelectField',
    selectionComponent: 'rfq.BreadCrumbsSelection',
    fieldStore: 'forms.ReferenceFieldStore',
    noValidation: true,
    labelKey: 'name',
    appKey: 'id',
    options: {
      type: 'treeOptions',
      allowNew: false,
      ArrayApp: 'ProcessesApp',
      query: 'rfq.ProcessesQuery',
      nestedSelectables: 'childProcesses',
      parentSelectable: 'parentProcess',
      optionComponent: 'rfq.MaterialOption',
      keepOpenOnSelect: false,
      requeryOn: ['processFilter'],
    },
  },
  material: {
    label: 'Material',
    placeholder: 'Choose Material',
    component: 'forms.SelectField',
    selectionComponent: 'rfq.BreadCrumbsSelection',
    fieldStore: 'forms.ReferenceFieldStore',
    noValidation: true,
    labelKey: 'name',
    appKey: 'id',
    options: {
      type: 'treeOptions',
      allowNew: false,
      ArrayApp: 'MaterialsApp',
      query: 'rfq.MaterialsQuery',
      nestedSelectables: 'childMaterials',
      parentSelectable: 'parentMaterial',
      optionComponent: 'rfq.MaterialOption',
      keepOpenOnSelect: false,
      requeryOn: ['materialFilter'],
    },
  },
  manufacturer: {
    label: 'Manufacturer',
    placeholder: 'Choose Manufacturer',
    component: 'forms.SelectField',
    fieldStore: 'forms.ReferenceFieldStore',
    labelKey: 'companyName',
    appKey: 'id',
    autocomplete: {
      allowNew: false,
      completeField: 'inputValue',
      completeVar: 'complete',
      queryWhenStart: true,
      // directly using javascript - depart from the pure config style
      // would cause a problem if we want to save form config server side.
      variablesTemplate: fieldStore => {
        return {
          first: () => 10,
          filters: () => {
            const completeVal =
              fieldStore[fieldStore.conf.autocomplete.completeField];
            if (!completeVal) {
              return [];
            }
            return [
              {
                field: 'companyName',
                operator: 'CONTAINS',
                values: [
                  {
                    valueString: completeVal,
                    valueType: 'STRING',
                  },
                ],
              },
            ];
          },
        };
      },
      placeholder: 'Type to search manufacturers...',
      query: 'manufacturer.ManufacturersQuery',
      optionComponent: 'tags.autocompleteElement',
    },
  },
  manufacturers: {
    label: 'Manufacturer',
    placeholder: 'Assign Manufacturers',
    component: 'forms.ListField',
    itemComponent: 'tags.itemComponent',
    prefixValue: '',
    labelKey: 'companyName',
    appKey: 'id',
    autocomplete: {
      allowNew: false,
      completeField: 'inputValue',
      completeVar: 'complete',
      placeholder: 'Type to search manufacturers...',
      query: 'manufacturer.ManufacturersQuery',
      optionComponent: 'tags.autocompleteElement',
    },
  },
  jobSpecQuantity: {
    label: 'Quantity',
    placeholder: 'e.g. 10',
    noValidation: true,
    component: 'forms.TextField',
    fieldStore: 'forms.IntegerFieldStore',
    minVal: 1,
    maxVal: 100000,
  },
};

export default conf;
